import { Component } from '@angular/core';

@Component({
    host: { 'test-id': 'user-sync-error' },
    selector: 'user-sync-error',
    template: `
    <fw-layout-context
      [title]="'fatalErrors.userSync.header' | translate"
      [description]="'fatalErrors.userSync.errorDetail' | translate"
      icon="rotate-refresh"
      iconColor="secondary"
    >
      <fw-button (click)="retry()" variant="outline" leftIcon="rotate-refresh" size="large">{{'common.actions.retry' | translate}}</fw-button>
    </fw-layout-context>
  `,
    styles: [`
    :host {
      width: 100vw;
      height: 100vh;
      background: var(--page-light);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  `],
    standalone: false,
})
export class UserSyncErrorComponent {

  retry(): void {
    location.reload();
  }
}
